"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = void 0;

var substrate = _interopRequireWildcard(require("./substrate"));

// Copyright 2017-2019 @polkadot/storage authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const storage = {
  substrate // Prefill storage with well known keys, as not returned by state_getMetadata

};
exports.storage = storage;